export const PERSON_TITLES = [
  "Mrs",
  "Mr",
  "Miss",
  "Ms",
  "Mx",
  "Dr",
  "Prof",
  "Baron",
  "Baroness",
  "Bishop",
  "Capt",
  "Col",
  "Countess",
  "Dame",
  "Esq",
  "Fr",
  "Gen",
  "Hon",
  "Imam",
  "Lady",
  "Lord",
  "Lt",
  "Maj",
  "Rabbi",
  "Rev",
  "Sheikh",
  "Sir",
  "Sister",
  "Viscount",
] as const
